import { Grid, Typography, Box, IconButton, List, ListItem, ListItemAvatar, ListItemText, ListItemSecondaryAction, CircularProgress } from '@mui/material';
import { handleLanguageChange, lang } from '../../utils/multiLangDashboardV2Data';
import { QueryRenderer } from '@cubejs-client/react'
import { url } from '../../config/urls'
import cubejs from '@cubejs-client/core'
import settings from "../../config/settings";
import { ReactComponent as TimerIcon } from "../../assets/icons/icon-timer.svg";
import { StringTruncate } from '../../utils/Reusables';
import { ReactComponent as ReportChart } from "../../assets/icons/icon-report-data.svg"
import {Skeleton} from '@mui/material';

const API_URL = url.cubeApiUrl
const CUBE_PUBLISHED_URL = url.cubePublishedApiUrl

const formatCustomData = (data) => {
    data.forEach(ele => {
        if (Object.keys(ele).length) {
            Object.keys(ele).forEach(k => {
                if (!ele[k]) {
                    ele[k] = 0
                }
            })
        }
    })
    return data
}

const formatStudentReportQuery = (studentId,keyTimeMetricsQuery) => {
    if(studentId && keyTimeMetricsQuery) {
            let dataSetName = null;
            if (keyTimeMetricsQuery?.dimensions?.length > 0) {
                dataSetName = keyTimeMetricsQuery?.dimensions[0]?.split('.')[0];
            }
            else if (keyTimeMetricsQuery?.measures?.length > 0) {
                dataSetName = keyTimeMetricsQuery?.measures[0]?.split('.')[0];
            }
            
            if(keyTimeMetricsQuery?.filters?.length ) {
                let ifExist = keyTimeMetricsQuery?.filters?.find(f => f?.member.includes('sUuid'))
                if(ifExist) {
                    ifExist.values = [studentId]
                }
                else {
                      keyTimeMetricsQuery?.filters.push({
                          member : `${dataSetName}.sUuid`,
                          operator: 'equals',
                          values: [studentId]
                      })

                }
            }
            else {
                keyTimeMetricsQuery?.filters.push({
                          member : `${dataSetName}.sUuid`,
                          operator: 'equals',
                          values: [studentId]
            })

            }
            keyTimeMetricsQuery = formatQueryFilter(keyTimeMetricsQuery)
            return keyTimeMetricsQuery
    }
    keyTimeMetricsQuery = formatQueryFilter(keyTimeMetricsQuery)
    return keyTimeMetricsQuery
}

const formatQueryFilter = (query) => {
    if(query?.filters?.length ) {
        query?.filters?.map(f => {
            if(f?.values && typeof f?.values[0] === 'number') {
                f.values = f?.values?.map(v => v?.toString())
            }else {
                return f
            }
        })    
    }
    return query
 }



const KeyTimePerformanceCard = (props) => {
    let cubejsApi = ""
    const CUBE_TOKEN = localStorage.getItem('cubeToken')
    if (CUBE_TOKEN)
        cubejsApi = cubejs(CUBE_TOKEN, { apiUrl: `${CUBE_PUBLISHED_URL}/cubejs-api/v1` })

    let { item, selectedProfile, profileReportIds, mapSubjectIconData, handleCustomDataFilter, handleCustomProfileDataFilter, handleCustomDateFilter, keyTimeMetricsQuery,studentId } = props
    let { keyTimePerformanceMetrics } = settings?.STUDENT_DASHBOARD_QUERY ?? {}
    let { highestPerform, leastPerform, Accuracy_Perc, overAllAtten, totalTimeMinute } = settings?.STUDENT_DASHBOARD_CALCULATED_FIELDS ?? {}
    let performanceKey = ''

    let statsTitle = ''
    switch (item?.title) {
        case 'High Performing':
            statsTitle = 'Area of Strength'
            performanceKey = highestPerform
            break;
        case 'Least Performing':
            statsTitle = 'Area of Improvement'
            performanceKey = leastPerform
            break;
        case 'Overall Accuracy':
            statsTitle = 'Overall-Acc'
            statsTitle = lang === 'en' ? statsTitle.replace('-Acc', '') : statsTitle
            performanceKey = Accuracy_Perc
            break;
        case 'Overall Attendance':
            statsTitle = 'Overall'
            performanceKey = overAllAtten
            break;
    }

    if (!keyTimeMetricsQuery) {
        return null
    }


    if (selectedProfile?.length && profileReportIds?.length && !profileReportIds.includes('keyTimePerformanceMetrics')) {
          return null
    }


    return (
        <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box className='er-keyareas'>
                <Box className="er-keyareas-heading">
                    <Typography variant='h4' >{handleLanguageChange("Learn & Practice - Learn Progress")}</Typography>
                </Box>
                <Box className="er-keyareas-content">
                    <List className='er-keyareas-items'>
                        <QueryRenderer
                            query={formatStudentReportQuery(studentId,keyTimeMetricsQuery)}
                            cubejsApi={cubejsApi}
                            render={({ resultSet, loadingState }) => {

                                if (loadingState?.isLoading) {
                                    return <Box className="width-100"> 
                                                <Skeleton className='progress-skeleton' animation="wave" />
                                                <Skeleton className='progress-skeleton half' animation="wave" />
                                            </Box>
                                }

                                let data1 = resultSet?.loadResponse?.results?.[0]?.data

                                if (data1?.length) {
                                    data1 = formatCustomData(data1)

                                    let keyAreaStats1 = data1.sort((a, b) => a[totalTimeMinute] - b[totalTimeMinute]).map(ele => {
                                        return { subject: ele[`${settings.PROGRESS_REPORT_DATASET}.subject`], time: ele[totalTimeMinute] }
                                    })

                                    return keyAreaStats1.map((item, i) => (
                                        <ListItem key={i} className="er-keyitem-listitem">
                                            <ListItemAvatar>
                                                {mapSubjectIconData(item?.subject)}
                                            </ListItemAvatar>
                                            <ListItemText className="label" title={item?.subject} primary={StringTruncate(item?.subject, 20)} />
                                            <ListItemSecondaryAction className="p-0 er-keyitem-listitem-action">
                                                <IconButton className='form-icon-btn key-timer-btn' edge="end" aria-label="">
                                                    <TimerIcon className="key-timer-btn-icon" />
                                                    <Typography className="action-label">{(item?.time ? item?.time : 0)} <br /> min</Typography>
                                                </IconButton>
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))
                                }

                                return (<Box className="width-100 text-center">
                                    <Box className='er-report-data-icon'><ReportChart /></Box>
                                    <Typography className="er-report-data-info" variant='h4'>{handleLanguageChange('No Data Found')}</Typography>
                                </Box>)
                            }}
                        />
                    </List>
                </Box>
            </Box>
        </Grid>
    )
}

export default KeyTimePerformanceCard